(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jd-email-capture"] && !Shopify.designMode) return;
  try {
    
(function () {
  // After the form round-trips, Shopify reloads the page with the success
  // markup rendered. Move focus to the confirmation so screen-reader and
  // keyboard users land on the success state (role="status" announces it).
  var success = document.querySelector('.jd-newsletter__success');
  if (!success) return;
  var prefersReduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  try {
    success.scrollIntoView({
      block: 'center',
      behavior: prefersReduced ? 'auto' : 'smooth',
    });
  } catch (e) {
    success.scrollIntoView();
  }
  success.focus();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jd-gift-tiers"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var els = (root || document).querySelectorAll('.jd-gift-tiers .jd-reveal:not(.jd-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('jd-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('jd-in'); obs.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState !== 'loading') { init(document); }
  else { document.addEventListener('DOMContentLoaded', function () { init(document); }); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jd-promise-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Re-run the global reveal observer so promises animate the moment the
  // merchant adds/edits the section in the theme editor (jd-theme.js only runs
  // its initial pass on full page load).
  if (window.JD && typeof window.JD.refreshReveal === 'function') {
    window.JD.refreshReveal();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jd-sampler-merchandiser"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Self-contained reveal observer: works even if no global one is present.
  // Idempotent — if .jd-in is already toggled globally, this is a harmless no-op.
  function init(root) {
    var els = (root || document).querySelectorAll('.jd-sampler-merch .jd-reveal:not(.jd-in)');
    if (!els.length) return;
    if (
      !('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      els.forEach(function (el) { el.classList.add('jd-in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('jd-in');
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState !== 'loading') {
    init(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  }

  // Re-scan when re-rendered inside the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jd-sticky-atc"] && !Shopify.designMode) return;
  try {
    
    (function () {
      var bar = document.querySelector('[data-jd-sticky-atc]');
      if (!bar) return;
      var addBtn = bar.querySelector('[data-jd-sticky-add]');
      var priceEl = bar.querySelector('[data-jd-sticky-price]');

      // The real add-to-cart button in the MAIN product form. Fallbacks stay
      // inside the product info container so they can never grab a card /
      // quick-add form elsewhere on the page.
      var realBtn =
        document.querySelector('#MainContent product-form button[name="add"]') ||
        document.querySelector('.product__info-container product-form button[name="add"]') ||
        document.querySelector('product-info product-form button[name="add"]') ||
        document.querySelector('.product-form__buttons button[name="add"]');
      if (!realBtn) return;

      addBtn.addEventListener('click', function () {
        realBtn.click();
      });

      // Mirror disabled state + label. On a post-add error Dawn hides the
      // button's <span> and reveals a separate .sold-out-message, so prefer
      // that when it's visible.
      function syncButton() {
        addBtn.disabled =
          realBtn.hasAttribute('disabled') ||
          realBtn.getAttribute('aria-disabled') === 'true';
        var soldOut = realBtn.querySelector('.sold-out-message');
        var label =
          soldOut && !soldOut.classList.contains('hidden')
            ? soldOut
            : realBtn.querySelector('span');
        var text = label ? label.textContent.trim() : realBtn.textContent.trim();
        if (text) addBtn.textContent = text;
      }
      syncButton();
      new MutationObserver(syncButton).observe(realBtn, {
        attributes: true,
        childList: true,
        subtree: true,
      });

      // Mirror the live price. Observe the STABLE container and re-query the
      // price node on each mutation, because Dawn replaces the price block's
      // innerHTML on every variant change (which detaches a cached node).
      var priceBox =
        document.querySelector('.product__info-container [id^="price-"]') ||
        document.querySelector('.product__info-container .price');
      if (priceBox && priceEl) {
        var syncPrice = function () {
          var node = priceBox.querySelector(
            '.price__sale .price-item--sale, .price__regular .price-item--regular, .price-item'
          );
          var t = node ? node.textContent.trim() : priceBox.textContent.trim();
          if (t) priceEl.textContent = t;
        };
        syncPrice();
        new MutationObserver(syncPrice).observe(priceBox, {
          childList: true,
          characterData: true,
          subtree: true,
        });
      }

      // Reveal the bar only when the real button is out of view.
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) bar.classList.remove('is-visible');
              else bar.classList.add('is-visible');
            });
          },
          { threshold: 0 }
        );
        io.observe(realBtn);
      }
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jd-testimonial-wall"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initSlider(root) {
    var wrap = root.querySelector('[data-jd-slider]');
    if (!wrap) return;
    var track = wrap.querySelector('.jd-testimonials__track');
    var prev = wrap.querySelector('[data-jd-prev]');
    var next = wrap.querySelector('[data-jd-next]');
    if (!track || !prev || !next) return;

    var reduce =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function step() {
      var slide = track.querySelector('.jd-testimonials__slide');
      if (!slide) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function scrollByDir(dir) {
      track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
    }

    function updateButtons() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= maxScroll;
    }

    prev.addEventListener('click', function () { scrollByDir(-1); });
    next.addEventListener('click', function () { scrollByDir(1); });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); scrollByDir(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); scrollByDir(-1); }
      else if (e.key === 'Home') { e.preventDefault(); track.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' }); }
      else if (e.key === 'End') { e.preventDefault(); track.scrollTo({ left: track.scrollWidth, behavior: reduce ? 'auto' : 'smooth' }); }
    });

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateButtons);
    });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  document.querySelectorAll('.jd-testimonials').forEach(initSlider);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.jd-testimonials');
    if (el) initSlider(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jd-trust-bar"] && !Shopify.designMode) return;
  try {
    
// Tap-to-play/stop for the optional marquee. Motion is STATE, not idle decoration:
// the strip is static by default and only sweeps while the user engages it. Touch
// devices have no :hover, so this tap toggle is the touch-equivalent of the
// hover/focus play states — and the sweep is always user-initiated, satisfying
// WCAG 2.2.2 (Pause, Stop, Hide) by never auto-starting in the first place.
(function () {
  function wire(track) {
    if (track.dataset.marqueeWired === 'true') return;
    track.dataset.marqueeWired = 'true';
    track.addEventListener('click', function (event) {
      // Don't hijack taps on a real link inside the strip.
      if (event.target.closest('a')) return;
      var playing = track.getAttribute('data-playing') === 'true';
      track.setAttribute('data-playing', playing ? 'false' : 'true');
    });
  }
  function init() {
    document
      .querySelectorAll('.jd-trustbar--marquee .jd-trustbar__track[data-marquee="true"]')
      .forEach(wire);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-wire when merchants add/edit the section in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
